module.exports = __webpack_public_path__ + "img/azores-islands.fa14146f.png";